import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="pt-20 pb-4">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-300 mx-1">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                )}
                {!isLast && item.path ? (
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className={`whitespace-nowrap ${isLast ? 'text-foreground-700 font-medium' : 'text-foreground-400'}`}>
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}